import { createTheme } from "@mui/material";
import indigo from "@mui/material/colors/indigo";
import pink from "@mui/material/colors/pink";
import {
  blackColor,
  errorColor,
  primaryColor,
  secondaryColor,
  successColor,
  warningColor,
  whiteColor,
} from "assets/colors";

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      contrastText: whiteColor,
    },
    secondary: {
      main: secondaryColor,
      contrastText: "#fff",
    },
    success: {
      main: successColor,
    },
    error: {
      main: errorColor,
    },
    warning: {
      main: warningColor,
      contrastText: whiteColor,
    },
    black: {
      main: blackColor,
      contrastText: whiteColor,
    },
    white: {
      main: whiteColor,
    },
  },
  status: {
    danger: "orange",
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: "capitalize",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
        },
      },
    },
  },
});
